// apps/web/src/lib/kanban/sequencia.ts — Fase 11 (WR-WEB-03).
// Token de sequência para cargas concorrentes: só a resposta da requisição mais recente vale.

export interface Sequenciador {
  /** Inicia uma nova requisição e devolve o seu identificador (invalida as anteriores). */
  proxima: () => number;
  /** O identificador ainda é o da requisição mais recente? */
  ehAtual: (id: number) => boolean;
}

export function criarSequenciador(): Sequenciador {
  let atual = 0;
  return {
    proxima: () => {
      atual += 1;
      return atual;
    },
    ehAtual: (id) => id === atual,
  };
}
